module.exports = __webpack_public_path__ + "img/helpharma.7a80c9d3.png";